module.exports = __webpack_public_path__ + "static/img/beta_bg_white_10.41d140b8.svg";